import { request } from "./client";
import USE_MOCK from "../mock/config";
import {
  mockFetchTenantConfigs,
  mockUpdateTenantConfig,
} from "../mock/mockHandlers";

const botConfigsPath = (botId) => `/bots/${botId}/configs`;

export const fetchTenantConfigs = (tenantId, options = {}) =>
  USE_MOCK ? mockFetchTenantConfigs(tenantId) : request(botConfigsPath(tenantId), options);
export const updateTenantConfigs = (tenantId, payload) =>
  USE_MOCK ? mockUpdateTenantConfig(tenantId, payload) : request(botConfigsPath(tenantId), { method: "PUT", data: payload });
